import * as bootstrap from "bootstrap"

'use strict';

/* ===== Enable Bootstrap Popover (on element  ====== */
const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))

/* ==== Enable Bootstrap Alert ====== */
//var alertList = document.querySelectorAll('.alert')
//alertList.forEach(function (alert) {
//  new bootstrap.Alert(alert)
//});

const alertList = document.querySelectorAll('.alert')
const alerts = [...alertList].map(element => new bootstrap.Alert(element))

/* ===== Responsive Sidepanel ====== */
function getSidePanel() {
  return document.getElementById('app-sidepanel');
}

function responsiveSidePanel() {
  const sidePanel = getSidePanel();
  if (!sidePanel) return;

  const isDesktop = window.innerWidth >= 1200;
  sidePanel.classList.toggle('sidepanel-visible', isDesktop);
  sidePanel.classList.toggle('sidepanel-hidden', !isDesktop);
}

function toggleSidePanel() {
  const sidePanel = getSidePanel();
  if (!sidePanel) return;

  const isVisible = sidePanel.classList.contains('sidepanel-visible');
  sidePanel.classList.toggle('sidepanel-visible', !isVisible);
  sidePanel.classList.toggle('sidepanel-hidden', isVisible);
}

function setMobileNavIcon(isOpen) {
  const mobileNavToggle = document.querySelector('.mobile-nav-toggle');
  if (!mobileNavToggle) return;

  mobileNavToggle.classList.toggle('bi-list', !isOpen);
  mobileNavToggle.classList.toggle('bi-x', isOpen);
}

function closeMobileNav() {
  document.body.classList.remove('mobile-nav-active');
  setMobileNavIcon(false);
}

function toggleMobileNav() {
  const isOpen = document.body.classList.toggle('mobile-nav-active');
  setMobileNavIcon(isOpen);
}

function toggleMobileSearch() {
  const searchBox = document.querySelector('.app-search-box');
  if (!searchBox) return;

  searchBox.classList.toggle('is-visible');

  const searchMobileTriggerIcon = document.querySelector('.search-mobile-trigger-icon');
  if (!searchMobileTriggerIcon) return;

  const isSearchVisible = searchBox.classList.contains('is-visible');
  searchMobileTriggerIcon.classList.toggle('fa-magnifying-glass', !isSearchVisible);
  searchMobileTriggerIcon.classList.toggle('fa-xmark', isSearchVisible);
}

function handleViewportChange() {
  responsiveSidePanel();

  if (window.innerWidth >= 1200) {
    closeMobileNav();
  }

  setMobileNavIcon(document.body.classList.contains('mobile-nav-active'));
}

function getEventTargetElement(event) {
  if (event.target instanceof Element) return event.target;
  if (event.target && event.target.parentElement instanceof Element) return event.target.parentElement;
  return null;
}

function handleDocumentClick(event) {
  const targetElement = getEventTargetElement(event);
  if (!targetElement) return;

  const sidePanelToggleElement = targetElement.closest('#sidepanel-toggler, #sidepanel-close, #sidepanel-drop');
  if (sidePanelToggleElement) {
    if (sidePanelToggleElement.id === 'sidepanel-close') {
      event.preventDefault();
    }
    toggleSidePanel();
    return;
  }

  if (targetElement.closest('.mobile-nav-toggle')) {
    if (event.defaultPrevented) return;
    event.preventDefault();
    toggleMobileNav();
    return;
  }

  if (targetElement.closest('#navmenu a') && document.body.classList.contains('mobile-nav-active')) {
    closeMobileNav();
    return;
  }

  if (targetElement.closest('.search-mobile-trigger')) {
    toggleMobileSearch();
  }
}

window.addEventListener('load', handleViewportChange);
window.addEventListener('resize', handleViewportChange);
document.addEventListener('turbo:load', handleViewportChange);
document.addEventListener('click', handleDocumentClick);
